var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-footer"},[_vm._m(0),_vm._v(" © "+_vm._s(_vm.footerSystemYear)+" Velocity Vehicle Group. All Rights Reserved. ")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",staticStyle:{"display":"none"}},[_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":"/static/images/loading.gif"}})])])
}]

export { render, staticRenderFns }